"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var condo_brain_1 = require("condo-brain");
var material_1 = require("@mui/material");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var Select_1 = __importDefault(require("@mui/material/Select"));
var InputLabel_1 = __importDefault(require("@mui/material/InputLabel"));
var List_1 = __importDefault(require("@mui/material/List"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var Switch_1 = __importDefault(require("@mui/material/Switch"));
var FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
var Dialog_1 = __importDefault(require("@mui/material/Dialog"));
var DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
var DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
var DialogContentText_1 = __importDefault(require("@mui/material/DialogContentText"));
var DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
var AmenityLi_1 = __importDefault(require("./AmenityLi"));
var useStyles = (0, makeStyles_1.default)(function (theme) { return (0, createStyles_1.default)({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '100%',
        },
    },
    registerButton: {
        backgroundColor: '#f37f30',
        color: 'white',
        marginBottom: '20px',
    },
    demo: {
        backgroundColor: theme.palette.background.paper,
    },
    title: {
        margin: theme.spacing(4, 0, 2),
    },
}); });
var minutesToReadable = function (t) {
    var hours = Math.floor(t / 60);
    var hourText = hours > 1 ? 'hours' : 'hour';
    var minutes = t % 60;
    var timeText = '';
    if (hours > 0) {
        timeText = "".concat(hours, " ").concat(hourText, " ");
    }
    if (minutes > 0) {
        timeText = "".concat(timeText, " ").concat(minutes, " minutes");
    }
    return timeText;
};
function AmenityAdmin() {
    var _this = this;
    var classes = useStyles();
    var _a = (0, react_1.useState)([]), amenities = _a[0], setAmenities = _a[1];
    var _b = (0, react_1.useState)(''), value = _b[0], setValue = _b[1];
    var _c = (0, react_1.useState)(true), visible = _c[0], setVisible = _c[1];
    var _d = (0, react_1.useState)(false), vaccine = _d[0], setVaccine = _d[1];
    var _e = (0, react_1.useState)(60), timeLimit = _e[0], setTimeLimit = _e[1];
    var _f = (0, react_1.useState)(undefined), selectedAmenity = _f[0], setSelectedAmenity = _f[1];
    var _g = (0, react_1.useState)(false), amenityOpen = _g[0], setAmenityOpen = _g[1];
    var _h = (0, react_1.useState)(0), amenityToDelete = _h[0], setAmenityToDelete = _h[1];
    var _j = react_1.default.useState(false), deleteOpen = _j[0], setDeleteOpen = _j[1];
    var admin = new condo_brain_1.AdminManager();
    if (!admin) {
        return (react_1.default.createElement("div", null));
    }
    var fetchAmenities = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            admin.getAmenities().then(function (response) {
                setAmenities(response);
            });
            return [2 /*return*/];
        });
    }); };
    function addAmenity(e) {
        e.preventDefault();
        var formData = new FormData();
        formData.append('resource[name]', value);
        formData.append('resource[time_limit]', String(timeLimit));
        formData.append('resource[visible]', String(visible));
        formData.append('resource[vaccine]', String(vaccine));
        admin.createAmenity(formData)
            .then(function (_response) {
            setValue('');
            fetchAmenities();
            setAmenityOpen(false);
        });
    }
    function doDeleteAmenity() {
        admin.deleteAmenity(amenityToDelete)
            .then(function (_response) {
            fetchAmenities();
            setDeleteOpen(false);
        });
    }
    function updateAmenity(e, amenity) {
        if (!amenity) {
            addAmenity(e);
            setAmenityOpen(false);
        }
        else {
            e.preventDefault();
            var formData = new FormData();
            formData.append('resource[name]', value);
            formData.append('resource[time_limit]', String(timeLimit));
            formData.append('resource[visible]', String(visible));
            formData.append('resource[vaccine]', String(vaccine));
            formData.append('resource[id]', String(amenity.id));
            admin.editAmenity(formData, amenity.id)
                .then(function (_response) {
                setValue('');
                fetchAmenities();
                setAmenityOpen(false);
            });
        }
    }
    var handleChange = function (event) {
        setValue(event.target.value);
    };
    var handleVisibilityChange = function (event) {
        setVisible(event.target.checked);
    };
    var handleVaccineChange = function (event) {
        setVaccine(event.target.checked);
    };
    (0, react_1.useEffect)(function () {
        fetchAmenities();
    }, [amenities.length]);
    var times = [];
    for (var t = 15; t <= 240; t += 15) {
        var timeText = minutesToReadable(t);
        times.push(react_1.default.createElement("option", { key: t, value: t }, timeText));
    }
    var handleTimeLimitChange = function (event) {
        var time = event.target.value;
        setTimeLimit(Number(time));
    };
    var deleteConfirmation = (react_1.default.createElement(Dialog_1.default, { open: deleteOpen, onClose: function () { return setDeleteOpen(false); }, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" },
        react_1.default.createElement(DialogTitle_1.default, { id: "alert-dialog-title" },
            "Delete",
            ' ',
            "\u201C", selectedAmenity === null || selectedAmenity === void 0 ? void 0 :
            selectedAmenity.name,
            "\u201D?"),
        react_1.default.createElement(DialogContent_1.default, null,
            react_1.default.createElement(DialogContentText_1.default, { id: "alert-dialog-description" }, "If you delete this amenity all associated reservations will also be deleted.")),
        react_1.default.createElement(DialogActions_1.default, null,
            react_1.default.createElement(Button_1.default, { onClick: function () { return setDeleteOpen(false); }, color: "primary" }, "Cancel"),
            react_1.default.createElement(Button_1.default, { onClick: function () { return doDeleteAmenity(); }, color: "primary", autoFocus: true }, "Save"))));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h4", { className: "center" }, "Amenity Admin"),
        react_1.default.createElement("div", { className: "section flex-grow" },
            react_1.default.createElement(material_1.Grid, { container: true, spacing: 5 },
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(List_1.default, null, amenities.map(function (amenity) { return (react_1.default.createElement(AmenityLi_1.default, { key: amenity.id, setAmenityToDelete: setAmenityToDelete, setSelectedAmenity: setSelectedAmenity, setDeleteOpen: setDeleteOpen, setTimeLimit: setTimeLimit, setValue: setValue, setVisible: setVisible, setVaccine: setVaccine, setAmenityOpen: setAmenityOpen }, amenity)); }))),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(Button_1.default, { className: classes.registerButton, variant: "contained", onClick: function () {
                            setTimeLimit(60);
                            setValue('');
                            setSelectedAmenity(undefined);
                            setAmenityOpen(true);
                        } }, "Add Amenity")))),
        react_1.default.createElement("form", { className: classes.root, noValidate: true, autoComplete: "off", onSubmit: addAmenity },
            react_1.default.createElement(Dialog_1.default, { open: amenityOpen, "aria-labelledby": "form-dialog-title" },
                react_1.default.createElement(DialogTitle_1.default, { id: "form-dialog-title" }, "Edit Amenity"),
                react_1.default.createElement(DialogContent_1.default, null,
                    react_1.default.createElement(DialogContentText_1.default, null, selectedAmenity === null || selectedAmenity === void 0 ? void 0 : selectedAmenity.name),
                    react_1.default.createElement(material_1.Grid, { container: true, spacing: 5 },
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                            react_1.default.createElement(TextField_1.default, { id: "standard-multiline-flexible", label: "Enter new amenity", multiline: true, maxRows: 4, value: value, onChange: handleChange, style: { width: '100%' } })),
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                            react_1.default.createElement(InputLabel_1.default, { htmlFor: "time-limit" }, "Time Limit"),
                            react_1.default.createElement(Select_1.default, { native: true, value: timeLimit, onChange: function () { return handleTimeLimitChange; }, inputProps: {
                                    name: 'timeLimit',
                                    id: 'timeLimit',
                                }, style: { width: '100%' } }, times)),
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                            react_1.default.createElement(FormControlLabel_1.default, { control: (react_1.default.createElement(Switch_1.default, { checked: visible, onChange: handleVisibilityChange, name: "visible", color: "primary" })), label: "Visible" })),
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                            react_1.default.createElement(FormControlLabel_1.default, { control: (react_1.default.createElement(Switch_1.default, { checked: vaccine, onChange: handleVaccineChange, name: "visible", color: "primary" })), label: "\uD83D\uDC89 Requires Vaccine" })))),
                react_1.default.createElement(DialogActions_1.default, null,
                    react_1.default.createElement(Button_1.default, { onClick: function () { return setAmenityOpen(false); }, color: "secondary" }, "Cancel"),
                    react_1.default.createElement(Button_1.default, { onClick: function (e) { return updateAmenity(e, selectedAmenity); }, color: "primary" }, "Save")))),
        deleteConfirmation));
}
exports.default = AmenityAdmin;
